import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-menu-close",
  "use": "icon-menu-close-usage",
  "viewBox": "0 0 17.9 17.9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17.9 17.9\" id=\"icon-menu-close\"><path d=\"M16.5 17.9L9 10.4l-7.5 7.5L0 16.5 7.5 9 0 1.4 1.4 0 9 7.5 16.5 0l1.4 1.4L10.4 9l7.5 7.5-1.4 1.4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol